import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-footer-page',
  templateUrl: './footer-page.component.html',
  styleUrls: ['./footer-page.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FooterPageComponent {
  ano: number;
  ngOnInit(){
    this.ano = new Date().getFullYear();
  }
}
